import { Component } from '@angular/core';
import { OERIService } from '../../../../services/oeri.service';
import { TableModule } from 'primeng/table';
import { Router, RouterModule } from '@angular/router';
import { CommonModule, NgClass, NgIf } from '@angular/common';
import saveAs from 'file-saver';
import { CommonService } from '../../../../services/common.service';
import { NotificationService } from '../../../../services/notification.service';


@Component({
    selector: 'app-match-oeri-open-tlr',
    imports: [TableModule, NgIf, NgClass, CommonModule],
    templateUrl: './match-oeri-open-tlr.component.html',
    styleUrl: './match-oeri-open-tlr.component.scss'
})
export class MatchOeriOpenTlrComponent {
  oeriData:any =[];
  isLoading: boolean = false;
  constructor(private oeriService: OERIService,private notificationService:NotificationService,private router:Router,private commonService:CommonService) { }
  oeriStatistics: any = {
    lastCalled: '',
    openTlr : 0,
    removedIn30days : 0
  };
  ngOnInit() {
    this.isLoading = true;
    this.getOERIStatistics();
    this.getOeriData();
  }
  getOERIStatistics(){
    this.oeriService.getOeriStatistics().subscribe((response: any) => {
      this.oeriStatistics.lastCalled = this.commonService.formatDateTime(response.oeriLastCalledTLR);
      this.oeriStatistics.openTlr = response.openTLRsToOERI;
      this.oeriStatistics.removedIn30days = response.removedTLRsLast30DaysToOERI;

    }, (error: any) => {
      console.error('Error fetching OERI data:', error);
    });
  }
  getOeriData() {
    this.oeriService.getOeriData().subscribe((response: any) => {
      this.oeriData = response.TableData || [];
      this.isLoading = false;
    }, (error: any) => {
      console.error('Error fetching OERI data:', error);
    });
  }

  
  details(row: any){
    this.router.navigate(['/details-section', row.Tag_Number]);
  }

  exportToExcel(){
    this.isLoading = true;
    this.oeriService.getOeriDataExcel()
    .subscribe({
        next: (fileData: any) => {
            if (fileData) {
                saveAs(fileData, 'TLR-OERIOpenTLR.xlsx');
            }
            this.isLoading = false;
            this.notificationService.showSuccess("file downloaded successfully");

        },
        error: (err: any) => {
            console.error('Error fetching report details:', err);
            this.isLoading = false;
        }
    });
  }
  getDateClass(date: Date): string {
    date = new Date(date); // Convert to Date object if it's a string
    const today = new Date();
    today.setHours(0, 0, 0, 0); // Reset time to midnight for comparison

    if (date < today) {
      return 'past-date';
    } else  {
        return 'future-date';
      }
  }
}
